import { createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mt-16 w-full grid scoreScaler place-items-center xl:mt-32" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-right pr-2 align-middle" }, [
  /*#__PURE__*/_createVNode("i", { class: "bg-black rounded-full text-brand-lightYellow2 emoticon fas fa-frown" })
], -1)
const _hoisted_3 = { class: "flex flex-row items-center relative" }
const _hoisted_4 = { class: "text-sm tear-text community xl:text-lg" }
const _hoisted_5 = { class: "text-sm tear-text player xl:text-lg" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "text-left pl-3 align-middle" }, [
  /*#__PURE__*/_createVNode("i", { class: "bg-black rounded-full text-brand-lightYellow2 emoticon fas fa-smile-beam" })
], -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", {
        class: "flex bg-brand-yellow2 transition tear absolute justify-center items-center",
        style: `left: ${_ctx.community}%`
      }, [
        _createVNode("p", _hoisted_4, [
          _createVNode("span", {
            class: { 'xl:text-3xl text-lg': !_ctx.isCommunity }
          }, _toDisplayString(_ctx.communityScoreText), 3)
        ])
      ], 4),
      _createVNode("div", {
        class: "flex bg-blue-500 transition tear absolute justify-center items-center",
        style: `left: ${_ctx.player}%`
      }, [
        _createVNode("p", _hoisted_5, [
          _createVNode("span", {
            class: { 'xl:text-3xl text-lg': _ctx.isCommunity }
          }, _toDisplayString(_ctx.playerScoreText), 3)
        ])
      ], 4),
      (_openBlock(), _createBlock(_Fragment, null, _renderList(6, (i) => {
        return _createVNode("div", {
          key: i,
          class: "bg-white flex-grow h-3 mx-1 colour-block md:mx-2"
        })
      }), 64 /* STABLE_FRAGMENT */))
    ]),
    _hoisted_6
  ]))
}